// src/icons/svgs/link-remove.svg
import * as React from "react";
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
var SvgLinkRemove = (props, ref) => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 8, height: 18, fill: "none", viewBox: "0 0 8 18", ref, ...props, children: /* @__PURE__ */ jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "M6.619 4.326a2.626 2.626 0 1 0-5.252 0v1.777a.5.5 0 0 1-1 0V4.326a3.626 3.626 0 1 1 7.252 0v1.777a.5.5 0 1 1-1 0zm0 9.348a2.626 2.626 0 1 1-5.252 0v-1.778a.5.5 0 0 0-1 0v1.778a3.626 3.626 0 1 0 7.252 0v-1.778a.5.5 0 0 0-1 0z", clipRule: "evenodd" }) });
var ForwardRef = forwardRef(SvgLinkRemove);
var link_remove_default = ForwardRef;
export {
  link_remove_default as LinkRemove
};
